import React, { useState } from "react";
import Footer from "../components/footer";
import dw from "web-digital-watermarking";
import { create } from "ipfs-http-client";

const infufaClient = create("https://ipfs.infura.io:5001/api/v0");

const Createpage = () => {
  // variables to capture image
  const [fileUpload, setFileUpload] = useState([]);
  const [uploadedPic, setUploadedPic] = useState();

  // Used pic and img to emphasize difference in encoded / decoded variable names
  const [encodedPicObj, setEncodedPicObj] = useState();
  const [decodedImgObj, setDecodedImgObj] = useState();
  const [iPFSfile, setIPFSfile] = useState();

  const [watermarkText, setWatermarkText] = useState();
  const [watrmarkfontSize, setWatermarkfontSize] = useState(Number(1.1));

  const [isLoading, setIsloading] = useState(false);

  const watermarkTextChangeHandler = (event) => {
    setWatermarkText(event.target.value);
  };
  const watrmarkfontSizeChangeHandler = (event) => {
    setWatermarkfontSize(Number(event.target.value));
  };

  function uploadFileChangeHandler(event) {
    var files = event.target.files;
    var filesArr = Array.prototype.slice.call(files);
    document.getElementById("file_name").style.display = "none";

    setFileUpload((prevState) => [prevState, ...filesArr]);

    setIPFSfile(files[0]);

    setUploadedPic(URL.createObjectURL(files[0]));
  }

  const decodeFunc = async () => {
    console.log("triggered decode function");
    setIsloading(true);
    const deCodeImageUrl = await dw.getTextFormImageUrl(uploadedPic);
    setDecodedImgObj(deCodeImageUrl);
    setIsloading(false);
  };

  const encodeFunc = async () => {
    console.log("triggered encode function");
    setIsloading(true);
    const enCodeImageUrl = await dw.transformImageUrlWithText(uploadedPic, watermarkText, watrmarkfontSize);
    setEncodedPicObj(enCodeImageUrl);
    setIsloading(false);
  };

  const uploadtoIPFS = async (file) => {
    try {
      const added = await infufaClient.add(file);
      console.log(`https://nftstorage.link/ipfs/${added.path}`);
      return await added.path;
    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  };

  return (
    <div>
      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row m-10-hor">
              <div className="col-12">
                <h1 className="text-center">Check for Hash</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container">
        <div className="row">
          <div className="col-lg-7 offset-lg-1 mb-5">
            <div id="form-create-item" className="form-border" action="#">
              <div className="field-set">
                <h5>Upload file</h5>

                <div className="d-create-file">
                  <p id="file_name">PNG, JPG, GIF, WEBP or MP4. Max 200mb.</p>
                  {fileUpload.map((x) => (
                    <p key={x}>PNG, JPG, GIF, WEBP or MP4. Max 200mb.{x.name}</p>
                  ))}
                  <div className="browse">
                    <input type="button" id="get_file" className="btn-main" value="Browse" />
                    <input id="upload_file" type="file" multiple onChange={uploadFileChangeHandler} />
                  </div>
                </div>
                <div className="spacer-single"></div>

                <button type="button" id="submit" className="btn-main" onClick={decodeFunc}>
                  Decode
                </button>
                {isLoading === true && (
                  <div>
                    <div className="spacer-10"></div>LOADING......
                  </div>
                )}
                {decodedImgObj !== undefined && isLoading === false && (
                  <div>
                    <div className="spacer-20"></div>
                    <h5>Decoded Image</h5>
                    <div className="nft_pic">
                      <img src={decodedImgObj} alt="" />
                    </div>
                  </div>
                )}

                <div className="spacer-single"></div>

                <h5>Watermark Text</h5>
                <input
                  type="text"
                  name="item_title"
                  id="item_title"
                  className="form-control"
                  placeholder="e.g. '0xabcdef1234567890..."
                  onChange={watermarkTextChangeHandler}
                />
                <h5>Font Size</h5>
                <input
                  type="number"
                  name="item_title"
                  id="item_title"
                  className="form-control"
                  placeholder="1.1"
                  onChange={watrmarkfontSizeChangeHandler}
                />
                <button type="button" id="submit" className="btn-main" onClick={encodeFunc}>
                  Encode
                </button>

                <div className="spacer-single"></div>

                <h5>Encoded Image</h5>
                <div className="nft_pic">
                  <img src={encodedPicObj} alt="" />
                </div>

                <button type="button" id="submit" className="btn-main" onClick={() => uploadtoIPFS(iPFSfile)}>
                  upload uploaded file to IPFS
                </button>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-sm-6 col-xs-12">
            <h5>Uploaded picture</h5>
            <div className="nft__item m-0">
              <div className="nft__item_wrap">
                <span>
                  <img src={uploadedPic} id="get_file_2" className="lazy nft__item_preview" alt="" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Createpage;
